import React from 'react'
import styled from 'styled-components'

import NoImage from '../../Shared/assets/no-picture-available-icon-1.jpeg'
import { venuePhotoAlt } from '../../venue-photo-alt'

import {
  tablet,
  mobile,
} from '../../styles'


const CardThumbnailWrapper = styled.div`
  flex: 0 0 auto;
`

const CardThumbnail = styled.img`
  height: 149px;
  width: 149px;
  border-radius: 4px;
  object-fit: cover;

  @media (max-width: ${tablet}) {
    height: 100%;
    width: 100px;
  }

  @media (max-width: ${mobile}) {
    height: auto;
    max-height: 320px;
    width: 100%;
    margin-top: 14px;
  }
`


// AEO-08a. Two attributes, one decision each.
//
// alt: the venue photo carries the venue's own sentence, so an answer engine
// reading the search results gets the setting, the type and the city from the
// picture as well as from the card text. The PLACEHOLDER gets alt="" instead.
// It is a grey "no picture available" graphic -- it says nothing about the
// venue, the card heading already carries the name, and an empty alt is how a
// parser is told to skip an image rather than describe it.
//
// width/height: 149x149 is the box the CSS already fixes on desktop, so
// nothing moves there. They earn their place at mobile width, where the CSS
// is `height: auto` and the box is reserved from the ratio in the HTML
// instead of collapsing to nothing until the photo arrives. Once the photo
// loads its own intrinsic ratio takes over, so the settled layout is
// unchanged. object-fit: cover keeps every ratio of photo undistorted.
const Thumbnail = ({ venue }) => {
  const photo = Array.isArray(venue?.photos) && venue.photos[0] ? venue.photos[0].thumbnail : null

  return (
    <CardThumbnailWrapper>
      <CardThumbnail
        src={photo || NoImage}
        alt={photo ? venuePhotoAlt(venue) : ''}
        width="149"
        height="149"
      />
    </CardThumbnailWrapper>
  )
}

export default Thumbnail
